window.onload = () => {
    chcekOverFlow();
};

window.addEventListener("resize", () => {
    chcekOverFlow();
})

function chcekOverFlow() {
    if (document.querySelector('.category-container')) {
        const divElement = document.querySelector('.category-container');
        const hasOverflow = divElement.scrollHeight > divElement.clientHeight || divElement.scrollWidth > divElement.clientWidth;
        if (hasOverflow) {
            if (divElement.classList.contains("category-container--no-overflow")) {
                divElement.classList.remove("category-container--no-overflow");
            }
        } else {
            divElement.classList.add("category-container--no-overflow");
        }
    }
}